export type RouteContext = {
  path: string;
};
export const RouteContext = (path: string): RouteContext => ({ path });
